export function getThumbPath(originalPath) {
  if (!originalPath) return originalPath;
  return originalPath
    .replace('/images/tiles/', '/images/tiles-thumb/')
    .replace(/\.(png|jpeg|webp)$/i, '.jpg');
}

export function getThumbPaths(images) {
  if (!images) return images;
  return images.map(getThumbPath);
}
